const state = {
  evidencias: {
    contrato_id: '',
    item_sla_id: '',
    mes_id: '',
    ano_selecionado: ''
  }
}

const mutations = {
  setEvidenciasPorMes (state, obj) {
    state.evidencias = obj
  }
}

export default {
  state,
  mutations
}



// WEBPACK FOOTER //
// ./src/vuex/modules/evidenciasPorMes.js